// extracted by mini-css-extract-plugin
module.exports = {"root":"AsicBtn-module--root--1XV6j","wrap":"AsicBtn-module--wrap--3124S"};